<footer>
    <!-- footer-28 block -->
    <section class="w3l-footer-28-main">
      <!-- <div class="footer-28 section-gap">
        <div class="wrapper">
          <div class="d-grid grid-col-4 footer-top-28">
            <div class="footer-list-28">
              <h6 class="footer-title-28">Menu Links</h6>
              <ul>
                <li><a href="about.html">About</a></li>
                <li><a href="services.html">Services</a></li>
                <li><a href="portfolio.html">Portfolio</a></li>
                <li><a href="team.html">Team</a></li>
              </ul>
            </div>
            <div class="footer-list-28">
              <ul>
                <h6 class="footer-title-28">Websites Links</h6>
                <li><a href="https://www.cairocure.com/">Cairo Cure</a></li>
                <li><a href="http://www.focus-its.net/">Focus For Software Technology</a></li>
                <li><a href="email-template.html">Email Template</a></li>

              </ul>
            </div>
            <div class="footer-list-28">
              <ul>
                <h6 class="footer-title-28">Shopping</h6>
                <li><a href="ecommerce.html">Ecommerce</a></li>
                <li><a href="ecommerce-single.html">Ecommerce Single</a></li>
                <li><a href="ecommerce-cart.html">Ecommerce Cart</a></li>
              </ul>
            </div>
            <div class="footer-list-28">
              <ul>
                <h6 class="footer-title-28">Account</h6>
                <li><a href="contact.html">Contact Us</a></li>
                <li><a href="appointment.html">Book Appointment</a></li>
                <li><a href="login.html">Login</a></li>
                <li><a href="signup.html">Register</a></li>
              </ul>
            </div>
          </div>
          <div class="midd-footer-28 align-center">
            <div class="main-social-footer-28">
              <a class="facebook" href="#facebook"><span class="fa fa-facebook" aria-hidden="true"></span></a>
              <a class="twitter" href="#twitter"><span class="fa fa-twitter" aria-hidden="true"></span></a>
              <a class="instagram" href="#instagram"><span class="fa fa-instagram" aria-hidden="true"></span></a>
              <a class="google" href="#google"><span class="fa fa-google-plus" aria-hidden="true"></span></a>
              <a class="pinterest" href="#pinterest"><span class="fa fa-pinterest-p" aria-hidden="true"></span></a>
            </div>
            <p class="copy-footer-28">&copy; 2020 Focus for Software Thechnology. All rights reserved.</p>
          </div>
        </div>
      </div> -->
      <!-- //footer-28 block -->
      <!-- move top -->
      <button onclick="topFunction()" id="movetop" title="Go to top">
        <span class="fa fa-arrow-up" aria-hidden="true"></span>
      </button>
      <!-- /move top -->
    </section>
  </footer>
